import {State} from "./types";
import {storage} from "../../../utils/storage";

export const initialState: State = {
  showOverlap: false,
  buttonLoaderIds: [],
  showMobileMenu: false,
  showFullScreenLoader: false,
  menuExpanded: storage["read"]("[menu-expanded]") as boolean,
  panel: {
    title: "",
    opened: false,
    width: undefined,
    component: undefined,
  },
};
